var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1814_18311)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M9.37991 14.0102H2.86964C2.09644 14.0102 1.46964 13.3834 1.46964 12.6102V4.14016M8.02078 1.2002H4.54977C3.96987 1.2002 3.49977 1.6703 3.49977 2.2502V11.8502C3.49977 11.9607 3.58931 12.0502 3.69977 12.0502H11.3398C11.9197 12.0502 12.3898 11.5801 12.3898 11.0002V5.56919C12.3898 5.55062 12.3824 5.53282 12.3693 5.51969L8.07027 1.2207C8.05715 1.20757 8.03934 1.2002 8.02078 1.2002Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M7.3501 5.40039V7.15039M7.3501 7.15039V8.90039M7.3501 7.15039C7.3501 7.15039 6.28352 7.15039 5.6001 7.15039M7.3501 7.15039H9.1001",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    className: "icon-svg",
    id: "clip0_1814_18311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPlan);
export default __webpack_public_path__ + "static/media/newPlan.2285c43e42599b9695fca3a8055fb441.svg";
export { ForwardRef as ReactComponent };